module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signUp($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("用户名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.username),
      expression: "formData.username"
    }],
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    attrs: {
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('input', {
    staticClass: "btn",
    attrs: {
      "type": "submit",
      "value": "提交"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "errorMessage"
  }, [_vm._v(_vm._s(_vm.errorMessage))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67dcc516"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignUpForm.vue
// module id = 82
// module chunks = 1